module.exports = __webpack_public_path__ + "img/skip.77c0feb6.svg";